import _size from 'lodash/size'

import Image from 'components/Image'
import Title from 'components/Title'
import Paragraph from 'components/Paragraph'
import Button from 'components/Button'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Carousel from 'components/Carousel'

import theme from 'style/theme'

import Styled from './styled'

const imagePerson = '/assets/images/person.png'
const imageArm = '/assets/images/arm.png'

export default function SectionPortfolio({ portfolios }) {
  const title = 'ผลงานที่ผ่านมา'
  const contents = portfolios
  const buttonText = 'ดูผลงานทั้งหมด'

  return (
    <Styled>
      <div className="image-person-block">
        <Image src={imagePerson} className="image-person" />
        <Image src={imageArm} className="image-arm" />
      </div>

      <div className="content">
        <Title level={2} className="title">
          {title}
        </Title>

        <div className="portfolio-content">
          <Carousel
            options={{
              spaceBetween: 15,
              slidesPerView: 1,
              pagination: true,
              navigation: {
                nextEl: '.swiper-button-custom-next',
                prevEl: '.swiper-button-custom-prev',
              },
              breakpoints: {
                992: {
                  slidesPerView: 3,
                  pagination: false,
                },
              },
            }}
            items={contents}
            uiRenderer={(item, index) => {
              const name = item?.title
              const detail = item?.shortDescription
              const image = item?.thumbnailImage?.[0]?.url
              const slug = item?.code
              const categorySlug = 'review'
              const link = `/blog/${categorySlug}/${slug}`

              return (
                <Link href={link} openNewTab={true} key={index}>
                  <div className="portfolio-item">
                    <div className="image-portfolio">
                      <Image src={image} imgixWidth={640} alt="" />
                    </div>

                    <div className="info-block">
                      <Title level={3} ellipsis={{ rows: 1 }}>
                        {name}
                      </Title>
                      <Paragraph className="detail" ellipsis={{ rows: 3 }}>
                        {detail}
                      </Paragraph>

                      <Paragraph className="read-more">อ่านรีวิวเพิ่มเติม</Paragraph>
                    </div>
                  </div>
                </Link>
              )
            }}
          />

          {_size(contents) > 3 && (
            <>
              <div className="swiper-button-custom swiper-button-custom-prev">
                <Icon.ChevronLeft style={{ fontSize: 40, color: theme.white }} />
              </div>
              <div className="swiper-button-custom swiper-button-custom-next">
                <Icon.ChevronRight style={{ fontSize: 40, color: theme.white }} />
              </div>
            </>
          )}
        </div>

        <div className="button-block">
          <Link href="/blog/review" openNewTab={true}>
            <Button size="large">{buttonText}</Button>
          </Link>
        </div>
      </div>
    </Styled>
  )
}
